import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Stage } from '@recruitee/stages-types';
import type { OverlayOriginDirective } from '@recruitee/user-interface';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  HeadingComponent,
  IconComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-anonymous-learn-more-overlay',
  templateUrl: './anonymous-learn-more-overlay.component.html',
  styleUrls: ['./anonymous-learn-more-overlay.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    TranslatePipe,
    HeadingComponent,
  ],
})
export class AnonymousLearnMoreOverlayComponent {
  public origin = input.required<OverlayOriginDirective>();

  /**
   * Stage in which the candidate is anonymized
   */
  public anonymousStage = input.required<Stage>();

  public DropdownWidth = DropdownWidth;

  private connectedOverlay = viewChild(ConnectedOverlayDirective);

  public toggleOverlay(): void {
    this.connectedOverlay()!.toggleOverlay(!this.connectedOverlay()!.open);
  }
}
